module.exports = __webpack_public_path__ + "static/overwrite-domain-9876252715050ed2971b9b69f5836b56.png";